var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,102.37333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 585.703,0.00390625 H 182.086 C 81.5195,0.00390625 0,81.5195 0,182.086 v 403.617 c 0,100.57 81.5195,182.086 182.086,182.086 h 403.617 c 100.567,0 182.09,-81.516 182.09,-182.086 V 182.086 C 767.793,81.5195 686.27,0.00390625 585.703,0.00390625",
    style: {
      fill: "#44b1ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 383.891,96 c -94.731,0 -186.84,33.547 -259.364,94.457 l 24.344,28.988 c 65.707,-55.191 149.18,-85.59 235.02,-85.59 85.843,0 169.312,30.399 235.027,85.59 l 24.348,-28.988 C 570.746,129.547 478.637,96 383.891,96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 391.988,471.328 c 19.532,0 34.172,4.344 43.942,13.024 9.761,8.683 14.636,22.785 14.636,42.316 0,18.805 -4.875,32.457 -14.636,40.961 -9.77,8.488 -24.41,12.746 -43.942,12.746 H 298.672 V 471.328 Z m 41.059,175.223 c 17.351,0 32.992,-2.805 46.937,-8.403 13.911,-5.617 25.84,-13.293 35.797,-23.058 9.942,-9.766 17.543,-21.074 22.778,-33.902 5.254,-12.844 7.882,-26.68 7.882,-41.504 0,-22.782 -4.816,-42.504 -14.39,-59.129 -9.59,-16.637 -25.231,-29.293 -46.918,-37.977 v -1.082 c 10.48,-2.906 19.164,-7.32 26.035,-13.297 6.859,-5.965 12.48,-13.015 16.816,-21.152 4.344,-8.137 7.504,-17.09 9.489,-26.856 1.996,-9.765 3.347,-19.531 4.07,-29.296 0.359,-6.153 0.719,-13.383 1.086,-21.692 0.348,-8.328 0.984,-16.828 1.902,-25.5 0.891,-8.68 2.344,-16.914 4.348,-24.683 1.969,-7.778 4.953,-14.379 8.934,-19.797 h -85.161 c -4.703,12.277 -7.586,26.937 -8.687,43.933 -1.082,17.004 -2.711,33.274 -4.871,48.832 -2.906,20.246 -9.043,35.075 -18.457,44.473 -9.403,9.414 -24.762,14.117 -46.102,14.117 h -85.18 V 259.223 h -85.171 v 387.328 h 208.863",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.91cf2384.svg";
export { ForwardRef as ReactComponent };